export const IconHotels = ({ style, className }) => {
  return (
    <svg
      style={style}
      className={className}
      width="32"
      height="32"
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M14.1336 5.5332V7.99984H12.1603C10.0137 7.99984 8.93367 9.07981 8.93367 11.2265V23.9998H5.53369C3.62702 23.9998 2.66699 23.0398 2.66699 21.1331V5.5332C2.66699 3.62654 3.62702 2.6665 5.53369 2.6665H11.267C13.1737 2.6665 14.1336 3.62654 14.1336 5.5332Z"/>
      <path opacity="0.4" d="M23.1602 11.2266V26.1067C23.1602 28.2534 22.0936 29.3333 19.9469 29.3333H12.1602C10.0136 29.3333 8.93359 28.2534 8.93359 26.1067V11.2266C8.93359 9.07998 10.0136 8 12.1602 8H19.9469C22.0936 8 23.1602 9.07998 23.1602 11.2266Z"/>
      <path d="M29.3338 5.5332V21.1331C29.3338 23.0398 28.3738 23.9998 26.4671 23.9998H23.1605V11.2265C23.1605 9.07981 22.0939 7.99984 19.9472 7.99984H17.8672V5.5332C17.8672 3.62654 18.8271 2.6665 20.7338 2.6665H26.4671C28.3738 2.6665 29.3338 3.62654 29.3338 5.5332Z"/>
      <path d="M18.6663 15.6665H13.333C12.7863 15.6665 12.333 15.2132 12.333 14.6665C12.333 14.1198 12.7863 13.6665 13.333 13.6665H18.6663C19.213 13.6665 19.6663 14.1198 19.6663 14.6665C19.6663 15.2132 19.213 15.6665 18.6663 15.6665Z"/>
      <path d="M18.6663 19.6665H13.333C12.7863 19.6665 12.333 19.2132 12.333 18.6665C12.333 18.1198 12.7863 17.6665 13.333 17.6665H18.6663C19.213 17.6665 19.6663 18.1198 19.6663 18.6665C19.6663 19.2132 19.213 19.6665 18.6663 19.6665Z"/>
      <path d="M17 25.3335V29.3335H15V25.3335C15 24.7868 15.4533 24.3335 16 24.3335C16.5467 24.3335 17 24.7868 17 25.3335Z"/>
    </svg>
  );
};
